// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";   


// export default function MEIS() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Merchandise Exports from India Scheme (MEIS)</h1>
//                                   <p>For the period 2015-2020, MEIS was included in the Foreign Trade Policy (FTP). The MEIS was established as a scheme to encourage the export of commodities. Exporters receive incentives in the form of duty credit scrips. The DGFT (Directorate General of Foreign Trade) notifies the MEIS, which is then implemented by the Ministry of Commerce and Industry.</p>
//                                   <p>The total reward that an IEC holder may receive under the Merchandise Exports from India Scheme (MEIS) for exports made between 01.09.2020 and 31.12.2020 [period based on Let Export Order (LEO) date of shipping bill(s)] must not exceed Rs. 2 Crore per IEC. Any IEC holder who has not made any exports with a LEO date between 01.09.2019 and 31.08.2020, or who has obtained a new IEC on or after 01.09.2020, would be ineligible to file a claim for MEIS benefits for exports made after 01.09.2020. The aforementioned ceiling may be further reduced to ensure that the total claim under the Scheme for the period (01.09.2020 to 31.12.2020) does not exceed the amount set above Rs. 5,000 crores.</p>
                                  
//                                 </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <h2>Incentives for MEIS</h2>
//                                   <p>MEIS proposes to incentivize exports of commodities made or produced in India under the FTP 2015-20. The incentives are for commodities that are commonly exported from India, as well as industries that produce or manufacture them, with the goal of making Indian exports more competitive.</p>
//                                   <p>MEIS includes goods that have been declared for the scheme's purposes. The schemes' incentives are based on a percentage of realised FOB (free-on-board) value exports in free foreign exchange or FOB value of exports as per shipping bills in free foreign exchange. A MEIS duty credit scrip is used to distribute the incentives.</p>
                              
//                                   <h2>Who qualifies for the MEIS Program?</h2>
//                                   <p>The following are the MEIS Scheme's eligibility requirements:</p>
//                                   <ul>
//                                       <li>All Indian exporters, whether merchant exporters (traders) or manufacturer exporters, who export products listed in Appendix 3B – MEIS Schedule are eligible to claim incentives under the MEIS Scheme.</li>
//                                       <li>Eligibility is determined solely by the product sold, not by the country of export, because the MEIS Scheme is open to all countries, according to the most recent circulars.</li>
//                                       <li>Benefits under the MEIS Scheme are also available to SEZ and EOU units.</li>
//                                       <li>MEIS does not have a minimum turnover requirement.</li>
//                                       <li>Goods shipped by courier from e-commerce platforms are also eligible</li>
//                                       <li>The exported products' country of origin must be India; re-exported products are not eligible.</li>
//                                       <li>Only those Shipping Bills with a "Declaration of Intent" and a "YES" for the Scheme incentive option are eligible for the MEIS Scheme.</li>
//                                   </ul>

//                                   <h2>Procedure for Applying for a MEIS Incentive</h2>
//                                   <p>To obtain duty credit scrip rights under MEIS, you must submit an online application in form ANF 3A with a digital signature.</p>
//                                   <p>Applicant shall file separate application for each port of export in case of Non EDI Shipping bills. In case of EDI shipping bills, the applicant can file a single application containing shipping bills of different EDI ports. Accordingly shipments from different EDI ports will not require separate applications</p>
//                                   <p>The MEIS application must be submitted within the following timeframe:</p>
                              
//                                   <ul>
//                                       <li>12 months from the LEO (Let Export) date; or</li>
//                                         <li>3 months from the date of customs' uploading of EDI shipping bills to the DGFT server, or printing / releasing of non-EDI shipping bills, whichever is later.</li>
//                                   </ul>
//                                     <p>Thereafter, late cut will be applicable for further two years.</p>

//                                   <h2>Application of the MEIS Incentive</h2>
//                                   <p>Under FTP 2015-20, duty credit scrips can be used to pay customs duties on inputs or goods imported, safeguard duties, anti-dumping duties, and any other customs duty. The scrips can also be exchanged and used to import items in exchange for them. Exporters can divide their duty credit scrip on the proviso that each scrip is worth at least Rs 5 lakh.</p>
//                                   <p>The request can be made at the timing of filing of online application, using the same port of registration as the original scrip. The process, however, is only relevant to EDI (Electronic Data Interchange) equipped ports.</p>
//                                   <p>The foreign exchange acquired through overseas credit cards and other instruments approved by the Reserve Bank of India would be included in the "free foreign exchange" (RBI).</p>
                                  
//                                   <h2>Notified Products MEIS refers to a set of rules that govern how</h2>
//                                     <p>Benefits are ineligible MEIS refers to a set of rules that govern how MEIS incentives are not available to the industries or segments listed below:</p>
//                                     <p>- DTA units export to SEZ/EOU/EHTP/FTWZ units.</p>
//                                     <p>- Deemed exports.</p>
//                                     <p>- Imported commodity exports are governed by FTP section 2.46.</p>
//                                     <p>- Export commodities with a minimum export duty or price.</p>
//                                     <p>- Trans-shipment exports, i.e., exports that originate in a third nation but are trans-shipped through India.</p>
//                                   <p>- Exports made by units in FTWZ.</p>
                                  
//                                   <p>Director General of Foreign Trade (DGFT) has announced a new scheme called “RoDTEP” and it stands for Remission of Duties and Taxes on Export Products. This is applicable with impact from January 1st, 2021, formed to replace the existing MEIS (Merchandise Exports from India Scheme). The scheme will make sure that the exporters get hold of the refunds at the embedded taxes and responsibilities formerly nonrecoverable. The scheme turned into introduced approximately a good way to increase exports which have been extraordinarily terrible in quantity formerly.</p>
//                                   <p>As per Notification No. 26/2015-2020 dated 16.09.2021, last date of Submitting applications for MEIS (for exports made in the period (s) 01.07.2018 to 31.03.2019, 01.04.2019 to 31.03.2020 and 01.04.2020 to 31.12.2020) stands revised to 31st December 2021</p>
//                                   <p>After 31.12.2021, no further applications would be allowed to be submitted and they would become timebarred. Late cut provisions shall also not be available for submitting claims at a later date.</p>
//                                   <p>Director General of Foreign Trade (DGFT) has announced a new scheme called “RoDTEP” and it stands for Remission of Duties and Taxes on Export Products. This is applicable with impact from January 1st, 2021, formed to replace the existing MEIS (Merchandise Exports from India Scheme). The scheme will make sure that the exporters get hold of the refunds at the embedded taxes and responsibilities formerly nonrecoverable. The scheme turned into introduced approximately a good way to increase exports which have been extraordinarily terrible in quantity formerly.</p>

//                                   <h2>How can we assist you in obtaining DGFT benefits under the MEIS scheme?</h2>
//                                   <ul>
//                                       <li>By assessing our clients' eligibility, we at Apex can advise them on the benefits they may be eligible for on their products.</li>
//                                       <li>We assist our clients with document preparation and provide hassle-free services.</li>
//                                       <li>Prepare and submit online applications for the MEIS License.</li>
//                                       <li>The registration of the licence is handled by our office on a one-on-one basis.</li>
//                                       <li>We also aid with the sale of licences and the papers required for the transfer of a licence to a buyer.</li>
//                                   </ul>

//                                   <h2>At Apex What We Do</h2>
//                                   <p>The main aspect of the scheme is promoting the manufacture and export of notified goods/products from India. The exporters are going to receive the reward in the form of an incentive of a fixed percentage on the FOB value of the exports. The percentage for various notified products is confirmed by DGFT and mentioned in Appendix 3B according to the ITC(HS) codes of the respective products. We conduct thorough the entire proceeding right from the time framing to arranging the license from DGFT.</p>
//                               </div> 
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaExclamationTriangle,
  FaHandsHelping
} from "react-icons/fa";

export default function MEIS() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">

            <Col lg={8}>
              <h1>
                Merchandise Exports from India Scheme (MEIS)
              </h1>

              <p>
                MEIS was introduced under Foreign Trade Policy (2015–2020)
                to promote exports of notified goods by providing incentives
                in the form of duty credit scrips.
              </p>

              <p>
                Although discontinued and replaced by RoDTEP, MEIS still
                remains relevant for pending claims, corrections, and advisory support.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>

          </Row>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> What is MEIS?
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Incentives based on export performance</li>
            <li><FaCheckCircle /> Rewards given as duty credit scrips</li>
            <li><FaCheckCircle /> Applicable on notified products (Appendix 3B)</li>
            <li><FaCheckCircle /> Based on FOB value of exports</li>
          </ul>

          {/* UPDATE */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Important Update
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Replaced by RoDTEP from 1st Jan 2021</li>
            <li><FaCheckCircle /> No new claims allowed</li>
            <li><FaCheckCircle /> Pending claims still require handling</li>
            <li><FaCheckCircle /> Advisory support still needed</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligibility
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Manufacturer exporters</li>
            <li><FaCheckCircle /> Merchant exporters</li>
            <li><FaCheckCircle /> SEZ & EOU units</li>
            <li><FaCheckCircle /> E-commerce exporters</li>
            <li><FaCheckCircle /> Goods must originate from India</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Incentives Under MEIS
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Rewards between 2% to 5%</li>
            <li><FaCheckCircle /> Based on FOB export value</li>
            <li><FaCheckCircle /> Issued as duty credit scrips</li>
            <li><FaCheckCircle /> Transferable and usable for customs duty</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> File application via DGFT (ANF 3A)</li>
            <li><FaCheckCircle /> Submit within prescribed timeline</li>
            <li><FaCheckCircle /> DGFT verification</li>
            <li><FaCheckCircle /> Scrip issuance</li>
          </ul>

          {/* DOCUMENTS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Documents Required
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> IEC Code</li>
            <li><FaCheckCircle /> Shipping bills</li>
            <li><FaCheckCircle /> Export invoices</li>
            <li><FaCheckCircle /> Bank Realisation Certificate (BRC)</li>
            <li><FaCheckCircle /> Digital Signature (DSC)</li>
          </ul>

          {/* NOT ELIGIBLE */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Not Eligible
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Deemed exports</li>
            <li><FaCheckCircle /> Re-exported goods</li>
            <li><FaCheckCircle /> Trans-shipment exports</li>
            <li><FaCheckCircle /> Certain SEZ/EOU supplies</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we assist in reviewing past export data,
            handling pending claims, resolving discrepancies, and ensuring
            maximum recovery of eligible MEIS benefits.
          </p>

          {/* WHY STILL IMPORTANT */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Why MEIS Still Matters
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Many exporters missed benefits</li>
            <li><FaCheckCircle /> Claims rejected due to errors</li>
            <li><FaCheckCircle /> Recovery opportunities still exist</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}